import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup, TabContent, TabPane, AccordionBody, AccordionHeader, AccordionItem, Accordion } from "reactstrap";
import "moment-timezone";
import "moment/locale/id";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";

// Formik
import * as Yup from "yup";
import { useFormik, Field, FieldArray } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { resetCompanyState, getCompany } from "../../../store/company/action";
import { resetLegalityDocumentState, getLegalityDocument } from "../../../store/legalityDocument/action";
import { resetBranchState, getBranch } from "../../../store/branch/action";
import { resetSalesWarrantyState, getSalesWarranty as onGetSalesWarranty, addNewSalesWarranty as onAddNewSalesWarranty, updateSalesWarranty as onUpdateSalesWarranty, deleteSalesWarranty as onDeleteSalesWarranty, getSalesWarrantyLoading, resetSalesWarrantyCreateState } from "../../../store/salesWarranty/action";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { resetClientState, getClient } from "../../../store/client/action";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";

const SalesWarranty = (props) => {
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalMediaApplicationDoc, setModalMediaApplicationDoc] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [indexPage, setIndexPage] = useState(0);
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, salesWarranties, isSalesWarrantyCreated, isSalesWarrantySuccess, loading, error, legalityDocuments, legalityDocumentLoading, companies, companyLoading, branches, branchLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    salesWarranties: state.SalesWarranty.salesWarranties,
    loading: state.SalesWarranty.loading,
    isSalesWarrantyCreated: state.SalesWarranty.isSalesWarrantyCreated,
    isSalesWarrantySuccess: state.SalesWarranty.isSalesWarrantySuccess,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    legalityDocuments: state.LegalityDocument.legalityDocuments,
    legalityDocumentLoading: state.LegalityDocument.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    error: state.SalesWarranty.error,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
  }));

  const [salesWarrantyList, setSalesWarrantyList] = useState([]);
  const [salesWarantyDoc, setSalesWarantyDoc] = useState([]);
  const [salesWarranty, setSalesWarranty] = useState(null);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [legalityDocumentList, setLegalityDocumentList] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();
  const [searchBranch, setSearchBranch] = useState("");

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditApllicationDoc, setIsEditApllicationDoc] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [positionMessage, setPositionMessage] = useState("");

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setSalesWarrantyList(salesWarranties);
  }, [salesWarranties]);

  useEffect(() => {
    if (branchSelected) {
      setPositionMessage(`${userData?.user?.user_department && userData?.user?.user_department?.name}, ${userData?.user?.user_position && userData?.user?.user_position?.name}`);

      dispatch(resetSalesWarrantyState());
      dispatch(onGetSalesWarranty({ type: "all" }));
      handleGetLegalityDocument(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected]);

  const handleGetLegalityDocument = (id) => {
    dispatch(resetLegalityDocumentState());
    dispatch(getLegalityDocument({ companyId: id, status: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(salesWarranties)) {
      setSalesWarrantyList(salesWarranties.map((el) => ({ ...el, isChecked: false })));
      setInfo(salesWarranties[salesWarranties.length - 1]);
    }
  }, [salesWarranties]);

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_customer",
        label: "Konsumen",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_agent",
        label: "Marketing",
        isSelected: true,
        data: [],
      },
      {
        id: "sales_detail",
        label: "Blok",
        isSelected: true,
        data: [],
      },
      {
        id: "sls_bb",
        label: "Bank",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "bankat",
        label: "Tgl Bank",
        isSelected: true,
        data: [],
      },
      {
        id: "sp3at",
        label: "Tgl SP3K",
        isSelected: true,
        data: [],
      },
      {
        id: "completedat",
        label: "Tgl Akad",
        isSelected: true,
        data: [],
      },
      {
        id: "credit_amount",
        label: "ACC KPR",
        isSelected: true,
        data: [],
      },
      {
        id: "total_amount",
        label: "Harus Bayar",
        isSelected: true,
        data: [],
      },
      {
        id: "book_amount",
        label: "Booking",
        isSelected: true,
        data: [],
      },
      {
        id: "handling_amount",
        label: "Administrasi",
        isSelected: true,
        data: [],
      },
      {
        id: "payment_customer_no",
        label: "No Pembayaran Konsumen",
        isSelected: true,
        data: [],
      },
    ];

    if (salesWarrantyList.length > 0) {
      salesWarrantyList.forEach((data) => {
        if (data.isChecked) {
          Object.entries(data).forEach(([key, value]) => {
            const doc = dataDoc.find((d) => d.id === key);
            if (doc) {
              if (doc.id === "transactionat" || doc.id === "bankat" || doc.id === "sp3at" || doc.id === "completedat") {
                doc.data.push(value !== null ? handleValidDate(value) : "-");
              } else if (doc.id === "sales_customer" || doc.id === "sales_agent" || doc.id === "sls_bb" || doc.id === "sales_bank_status" || doc.id === "sales_branch" || doc.id === "sales_company" || doc.id === "sales_client") {
                doc.data.push(value?.name ?? "-");
              } else if (doc.id === "book_amount" || doc.id === "handling_amount" || doc.id === "credit_amount" || doc.id === "total_amount") {
                doc.data.push(currencyFormat(value === null ? 0 : value));
              } else if (doc.id === "sales_status") {
                doc.data.push(`${value?.name} - ${data.sales_deal_status?.name}`);
              } else if (doc.id === "sales_detail") {
                doc.data.push(`${value[0]?.sales_detail_product?.product_block?.name ?? ""} - ${value[0]?.sales_detail_product?.name ?? ""}`);
              } else {
                doc.data.push(value);
              }
            }
          });
        }
      });
    }

    setSalesWarantyDoc(dataDoc);
  }, [salesWarrantyList]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var branchData = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, sbum: parseFloat(item.sbum) };
        opt.push(obj);
      });
      var option = { options: opt };
      branchData.push(option);
      setBranchList(branchData);
    }
  }, [branches]);

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setSalesWarranty(null);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleSalesWarrantyClick = useCallback(
    (arg, type) => {
      const data = arg;
      let arrLegal = [];
      if (data.legality && data.legality.length > 0) {
        for (const d of data.legality) {
          arrLegal.push(d);
        }
      } else {
        for (const d of legalityDocuments) arrLegal.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
      }
      setCheckDocumentList(arrLegal);

      data.legality = arrLegal;

      setSalesWarranty(data);
      setIsEdit(true);
      toggle();
    },
    [toggle, legalityDocuments]
  );

  const checkedAll = () => {
    const allChecked = salesWarrantyList.every((item) => item.isChecked);
    const updatedData = salesWarrantyList.map((item) => ({
      ...item,
      isChecked: !allChecked,
    }));

    setSalesWarrantyList(updatedData);
  };

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={salesWarrantyList.every((item) => item.isChecked)} onChange={checkedAll} />,
        filterable: false,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 pe-0 me-0">
              <input
                type="checkbox"
                className="dataCheckbox me-2 form-check-input"
                checked={data.isChecked}
                onChange={() => {
                  const updatedData = salesWarrantyList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
                  setSalesWarrantyList(updatedData);
                }} />
              <ButtonGroup className="m-0">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      // handleSalesWarrantyClick(data, "detail");
                    }}>
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                  <Button
                    color="light"
                    className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateSales") !== -1 ? "btn-sm" : "btn-sm d-none"}
                    onClick={() => {
                      setInfo(data);
                      handleSalesWarrantyClick(data);
                    }}>
                    <i className="ri-edit-2-line fs-15"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "No Transaksi",
        accessor: "transaction_no",
        filterable: true,
        Cell: (cell) => {
          let data = cell.row.original;
          return (
            <div className="mb-1">
              <Link
                to="#"
                className="fw-semibold"
                onClick={() => {
                  setInfo(data);
                }}>
                {data.transaction_no}
              </Link>
            </div>
          );
        },
      },
      {
        Header: "Konsumen",
        accessor: "sales_customer.name",
        filterable: true,
        Cell: (data) => {
          let custName = data.row.original.sales_customer && data.row.original.sales_customer.name;
          let agentName = data.row.original.sales_agent && <span className="badge text-uppercase badge-soft-info mt-1">{data.row.original.sales_agent.name}</span>;
          return (
            <>
              <div className="mb-1">{custName}</div>
              {agentName}
            </>
          );
        },
      },
      {
        id: "Marketing",
        Header: "Marketing",
        accessor: "sales_agent.name",
        filterable: true,
      },
      {
        id: "Proyek",
        Header: "Proyek",
        accessor: "sales_branch.name",
        filterable: true,
      },
      {
        id: "Tanggal",
        Header: "Tanggal",
        accessor: "transactionat",
        filterable: false,
        Cell: (data) => {
          return data.row.original.transactionat ? handleValidDate(data.row.original.transactionat) : "";
        },
      },
    ],
    [salesWarrantyList, handleSalesWarrantyClick, userRole, userType]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: salesWarrantyList,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Marketing", "Status", "Proyek", "Booking"],
        pageIndex: indexPage,
        pageSize: 10,
        selectedRowIds: 0,
        sortBy: [
          {
            id: "Tanggal",
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetSalesWarranty(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setSalesWarrantyList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetSalesWarrantyState());
    dispatch(onGetSalesWarranty({ type: "all" }));
    handleGetLegalityDocument(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (salesWarranty && salesWarranty.id) || 0,
      legality: (salesWarranty && salesWarranty.legality) || [],
    },
    validationSchema: Yup.object({}),
    onSubmit: (values) => {
      dispatch(getSalesWarrantyLoading());
      if (values.id > 0) {
        let editSubmit = {
          id: values.id,
          legality: values.legality,
        };
        dispatch(onUpdateSalesWarranty(editSubmit));
      } else {
        toast.error("Silahkan isi JUMLAH pembayaran untuk menyimpan data Transaksi Pembayaran", { position: "bottom-left", autoClose: 5000 });
      }
      validation.resetForm();
      toggle();
    },
  });

  document.title = "Pelepasan Hak (SPH) | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesWarrantyList} />
      <Container fluid>
        <BreadCrumb title="Pertanahan" pageTitle="Sertifikat Pecahan">
          <div className="flex-shrink-0">
            <ExportDoc data={salesWarantyDoc} />
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={7}>
            <Card>
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    {loading && (
                      <>
                        <Spinner color="primary" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                        <Spinner color="success" type="grow" size={"sm"}>
                          Loading...
                        </Spinner>
                        &nbsp;
                      </>
                    )}
                  </h5>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div className="border-top">
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={7}>
                          <div className="me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                            gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            {/* <i className="bx bx-search-alt search-icon"></i> */}
                          </div>
                        </Col>
                        <Col sm={3}>
                          <div className="me-2 mb-3 col-12">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Filter date"
                              value={filterDate}
                              options={{
                                mode: "range",
                                dateFormat: "Y/m/d",
                              }}
                              onChange={(selectedDates, dateStr) => {
                                setFilterDate(dateStr);
                              }}
                            />
                            {/* <i className="bx bx-calendar-alt search-icon"></i> */}
                          </div>
                        </Col>
                        <Col sm={1}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1" style={{ minHeight: "320px" }}>
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>
                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>
                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} value={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="xl">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Form Legalitas" : "Form Legalitas"}
                  </ModalHeader>
                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <ModalBody>
                      <CardBody className={validation.values.statusId > 1 && parseFloat(validation.values.book_amount) > 1 ? "border-bottom ps-4 pe-4 position-relative" : "ps-4 pe-4 position-relative d-none"}>
                        <Row>
                          <Col lg={5} className="ms-auto">
                            <div className="row">
                              <div className="mb-1 fs-16 fw-semibold">{validation.values.company && validation.values.company.label}</div>
                              <div className="mb-1 fs-14">{validation.values.branch && validation.values.branch.label}</div>
                              <div className="mb-3 fs-14">{validation.values.sales_type && validation.values.sales_type.label}</div>
                            </div>
                          </Col>
                          <Col lg={3}></Col>
                          <Col lg={4} className="ms-auto">
                            <div className="mb-2 fs-14 fw-semibold">No Penjualan : {validation.values.code && validation.values.code}</div>
                            <div className="mb-2 fs-14 fw-semibold">Bank Pengajuan : {validation.values.sls_bb && validation.values.sls_bb.label}</div>
                            <div className="mb-2 fs-14 fw-semibold">{validation.values.agent && validation.values.agent.label}</div>
                            <div className="mb-1 fs-14 fw-semibold">{validation.values.customer && validation.values.customer.label}</div>
                          </Col>
                        </Row>
                      </CardBody>
                      <CardBody className="pt-0 pb-4 ps-4 pe-4">
                        <h4 className="mb-3 border-bottom pb-3">Legalitas Dokumen</h4>
                        {legalityDocuments.map((o, idx) => {
                          if (validation.values.legality.length > 0) {
                            return (
                              <div key={idx} className="row ms-1">
                                <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-3">
                                  <Input
                                    className={"form-check-input checked-all checked-method-all check-" + o.id + idx}
                                    type="checkbox"
                                    role="switch"
                                    value={validation.values.legality[idx]?.id}
                                    defaultChecked={o.id === validation.values.legality[idx]?.id && validation.values.legality[idx]?.id !== 0 ? true : false}
                                    onChange={(e) => {
                                      if (e.target.checked) validation.setFieldValue(`legality[${idx}].id`, o.id);
                                      else validation.setFieldValue(`legality[${idx}].id`, 0);
                                    }} />
                                  <Label className="form-check-label text-dark text-uppercase" htmlFor={"check-" + o.id + idx}>
                                    {o.name}
                                  </Label>
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Target"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      validation.setFieldValue(`legality[${idx}].targetat`, dateStr);
                                    }}
                                    value={validation.values.legality[idx]?.targetat} />
                                </div>
                                <div className="mb-2 col-lg-2">
                                  <Flatpickr
                                    className="form-control"
                                    placeholder="Actual"
                                    options={{ mode: "single", dateFormat: "Y/m/d" }}
                                    onChange={(selectedDates, dateStr) => {
                                      if (validation.values.legality[idx]) validation.values.legality[idx].actualat = dateStr;
                                    }}
                                    value={validation.values.legality[idx]?.actualat} />
                                </div>
                                <div className="mb-2 col-lg-5">
                                  <Input
                                    type="textarea"
                                    className="form-control"
                                    placeholder="Keterangan jika ada"
                                    value={validation.values.legality[idx]?.description}
                                    onChange={(e) => {
                                      validation.setFieldValue(`legality[${idx}].description`, e.target.value);
                                    }} />
                                </div>
                              </div>
                            );
                          } else return null;
                        })}
                      </CardBody>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button
                          type="button"
                          className="btn btn-light"
                          onClick={() => {
                            setModal(false);
                            validation.resetForm({});
                          }}>TUTUP
                        </button>
                        <button type="submit" className="btn btn-success" disabled={loading}>
                          <span className="d-flex align-items-center">
                            {"SIMPAN DATA"}&nbsp;{" "}
                            {loading && (
                              <Spinner size="sm" className="flex-shrink-0" role="status">
                                Loading...
                              </Spinner>
                            )}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body">
                <table className="table border table-responsive fs-13 mb-3">
                  <tbody>
                    <tr>
                      <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                        DATA LEGALITAS DOKUMEN
                      </td>
                    </tr>
                    {info.legality &&
                      info.legality.map((row, idx) => {
                        return (
                          <Fragment key={idx}>
                            <tr>
                              <td className="p2 border-top-0">
                                <span className="fw-semibold">
                                  <i className={row.id ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line text-danger me-1"}></i> {row.name ? row.name : "-"}
                                </span>
                                , {row.targetat ? row.targetat : "-"} s.d {row.actualat ? row.actualat : "-"}
                              </td>
                            </tr>
                            {row.description && row.description !== "" && (
                              <>
                                <tr>
                                  <td className="p2 border-0">Keterangan : {row.description ? row.description : "-"}</td>
                                </tr>
                                <tr>
                                  <td className="p0 border-top-0"></td>
                                </tr>
                              </>
                            )}
                          </Fragment>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
SalesWarranty.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SalesWarranty));
